import Color from 'color'

import client from 'webpack-theme-color-replacer/client'
import forElementUI from 'webpack-theme-color-replacer/forElementUI'
import appConfig from '../../config/appConfig.js'

export let curColor = appConfig.themeColor
export let linnerColor = appConfig.linnerColor

// 动态切换主题色
export function changeThemeColor(newColor, newlinnerColor) {
  var options = {
    oldColors: [
      ...forElementUI.getElementUISeries(linnerColor),
      ...forElementUI.getElementUISeries(curColor), 
      Color.rgb(curColor).rotate(-30).rgb().hex(),
    ],

    newColors: [
      ...forElementUI.getElementUISeries(newlinnerColor),
      ...forElementUI.getElementUISeries(newColor),
      Color.rgb(newColor).rotate(-30).rgb().hex(),
    ],
  }
  var promise = client.changer.changeColor(options, Promise);
  curColor = newColor
  localStorage.setItem('theme_color', curColor)
  return promise
}
// export function changeThemeLinnerColor(newlinnerColor) {
//   var options = {
//     oldColors: [
//       ...forElementUI.getElementUISeries(linnerColor), 
//       Color.rgb(linnerColor).rotate(30).rgb().hex(),
//     ],

//     newColors: [
//       ...forElementUI.getElementUISeries(newlinnerColor),
//       Color.rgb(newlinnerColor).rotate(30).rgb().hex(),
//     ],
//   }
//   var promise = client.changer.changeColor(options, Promise);
//   return promise
// }

export let savedColor = function() {
  return localStorage.getItem('theme_color') || appConfig.themeColor
}

export function initThemeColor() {
  changeThemeColor(savedColor())
}
export function initAdminColor() {
  changeThemeColor('#B27DFF', '#D460CF')
}
export function initTaokeColor() {
  changeThemeColor('#409EFF', '#7D8AFF')
}
